export default "__VITE_ASSET__CTjRIlVp__"